import { render } from "./TypeOfPaymentNotMulptiplyPayment.vue?vue&type=template&id=8c256bcc"
import script from "./TypeOfPaymentNotMulptiplyPayment.vue?vue&type=script&lang=js"
export * from "./TypeOfPaymentNotMulptiplyPayment.vue?vue&type=script&lang=js"

import exportComponent from "D:\\facturacion electronica\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__